import { __decorate, __extends } from "tslib";
import { CustomElement, upgradeProperty, FoundationProperty, attachShadowTemplate, coerceBoolean } from '@tyler-components-web/core';
import { SelectDropdownFoundation } from './select-dropdown-foundation';
import { SELECT_DROPDOWN_CONSTANTS } from './select-dropdown-constants';
import { BaseSelectComponent } from '../core/base-select';
import { BASE_SELECT_CONSTANTS } from '../core/base-select-constants';
import { SelectDropdownAdapter } from './select-dropdown-adapter';
import { OptionComponent } from '../option';
import { OptionGroupComponent } from '../option-group';
import { PopupComponent } from '../../popup';
import { ListComponent, ListItemComponent } from '../../list';
import { ProgressSpinnerComponent } from '../../progress-spinner';
import { ScaffoldComponent } from '../../scaffold';
import { ToolbarComponent } from '../../toolbar';
import { IconButtonComponent } from '../../icon-button';
var template = require('./select-dropdown.html');
var styles = require('./select-dropdown.css');
var SelectDropdownComponent = /** @class */ (function (_super) {
    __extends(SelectDropdownComponent, _super);
    function SelectDropdownComponent() {
        var _this = _super.call(this) || this;
        attachShadowTemplate(_this, SELECT_DROPDOWN_CONSTANTS.elementName, template, styles);
        _this._foundation = new SelectDropdownFoundation(new SelectDropdownAdapter(_this));
        return _this;
    }
    Object.defineProperty(SelectDropdownComponent, "observedAttributes", {
        get: function () {
            return [
                SELECT_DROPDOWN_CONSTANTS.attributes.TARGET,
                SELECT_DROPDOWN_CONSTANTS.attributes.SELECTED_TEXT_TARGET,
                SELECT_DROPDOWN_CONSTANTS.attributes.SYNC_SELECTED_TEXT,
                BASE_SELECT_CONSTANTS.attributes.VALUE,
                BASE_SELECT_CONSTANTS.attributes.MULTIPLE,
                BASE_SELECT_CONSTANTS.attributes.OBSERVE_SCROLL,
                BASE_SELECT_CONSTANTS.attributes.OBSERVE_SCROLL_THRESHOLD,
                BASE_SELECT_CONSTANTS.attributes.HIGHLIGHT_FIRST,
                BASE_SELECT_CONSTANTS.attributes.SELECT_ON_BLUR,
                BASE_SELECT_CONSTANTS.attributes.HIGHLIGHT_FIRST,
                BASE_SELECT_CONSTANTS.attributes.POPUP_CLASSES,
                BASE_SELECT_CONSTANTS.attributes.OPTION_LIMIT,
                BASE_SELECT_CONSTANTS.attributes.SYNC_POPUP_WIDTH
            ];
        },
        enumerable: true,
        configurable: true
    });
    SelectDropdownComponent.prototype.initializedCallback = function () {
        _super.prototype.initializedCallback.call(this);
        upgradeProperty(this, 'target');
        upgradeProperty(this, 'selectedTextTarget');
        upgradeProperty(this, 'syncSelectedText');
    };
    SelectDropdownComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        switch (name) {
            case SELECT_DROPDOWN_CONSTANTS.attributes.TARGET:
                this.target = newValue;
                return;
            case SELECT_DROPDOWN_CONSTANTS.attributes.SELECTED_TEXT_TARGET:
                this.selectedTextTarget = newValue;
                return;
            case SELECT_DROPDOWN_CONSTANTS.attributes.SYNC_SELECTED_TEXT:
                this.syncSelectedText = coerceBoolean(newValue);
                return;
        }
        _super.prototype.attributeChangedCallback.call(this, name, oldValue, newValue);
    };
    __decorate([
        FoundationProperty()
    ], SelectDropdownComponent.prototype, "target", void 0);
    __decorate([
        FoundationProperty()
    ], SelectDropdownComponent.prototype, "selectedTextTarget", void 0);
    __decorate([
        FoundationProperty()
    ], SelectDropdownComponent.prototype, "syncSelectedText", void 0);
    SelectDropdownComponent = __decorate([
        CustomElement({
            name: SELECT_DROPDOWN_CONSTANTS.elementName,
            dependencies: [
                OptionComponent,
                OptionGroupComponent,
                PopupComponent,
                ListComponent,
                ListItemComponent,
                ProgressSpinnerComponent,
                ScaffoldComponent,
                ToolbarComponent,
                IconButtonComponent
            ]
        })
    ], SelectDropdownComponent);
    return SelectDropdownComponent;
}(BaseSelectComponent));
export { SelectDropdownComponent };
